


























import { POSTicket } from '@pos/interfaces/pos-v2';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'bpc-pos-ticket-tabs',
  components: {},
})
export default class PosTicketTabs extends Vue {
  // PROPS
  @Prop({ type: Object }) readonly value: POSTicket;
  @Prop({ type: Number, required: true }) readonly posSessionId: number;
  @Prop({ type: Number, required: true }) readonly openedTicketReloadKey: number;
  @Prop({ type: String, default: null }) readonly initialTicketId: string | null;

  // DATA
  openedTickets: POSTicket[] = [];
  ticketsLoaded: boolean = false;
  addTicketButtonDisabled: boolean = false;
  // COMPUTED
  get model(): POSTicket {
    return this.value;
  }

  set model(value: POSTicket) {
    this.$emit('input', value);
  }

  /* Lifecycle hooks */
  // created() {}
  mounted() {
    this.getOpenedTickets();
  }
  // updated() {}
  // destroyed() {}
  async addNewTicket() {
    // TODO implement this
    this.addTicketButtonDisabled = true;
    const ticket = await this.$posService.addNewTicket(this.posSessionId);
    this.openedTickets.push(ticket);
    this.model = ticket;
    this.ticketChanged();
    this.addTicketButtonDisabled = false;
  }

  async ticketChanged() {
    this.$emit('ticket-changed');
  }

  async getOpenedTickets() {
    this.ticketsLoaded = false;
    console.log('ticketId :' + this.initialTicketId);
    this.openedTickets = await this.$posService.getOpenedTickets(this.posSessionId);
    if (!this.model && this.openedTickets.length > 0 && !this.initialTicketId) {
      this.model = this.openedTickets[this.openedTickets.length - 1];
    } else if (!this.model && this.openedTickets.length > 0 && this.initialTicketId) {
      this.model = this.openedTickets.find(ticket => ticket.id === Number(this.initialTicketId));
    }
    this.ticketsLoaded = true;
    //to open a ticket when no ticket is opened, uncomment those lines
    /*if (this.openedTickets.length === 0) {
      this.addNewTicket();
    }*/
  }
  searchTicket() {
    this.$emit('search-ticket');
  }

  @Watch('openedTicketReloadKey')
  async onOpenedTicketReloadKeyChange() {
    await this.getOpenedTickets();
  }
}
